import { useEffect } from 'react';
import { generateSystemName } from '../utils/create';
import { getGoogleAnalyticsClientId } from '../utils/google';
import { consumeSearchParam } from '../utils/url';

export const useSso = ({ consentText, getRecaptchaToken, locale, region, setError, ssoGoogleUrl, ssoMicrosoftUrl }) => {
	useEffect(() => {
		const errorUrlParameter = consumeSearchParam('error');
		if (errorUrlParameter) {
			// Set error based on the URL parameter
			// If the error is 'email_not_verified', we set a specific error message
			setError(errorUrlParameter === 'email_not_verified' ? `sso_${errorUrlParameter}` : 'sso_general');
		}
	}, []);

	const redirectToSsoUrl = async (url) => {
		const params = {
			locale,
			region,
			tosConsentText: consentText,
			systemName: generateSystemName(),
		};

		if (getGoogleAnalyticsClientId()) {
			params.gaClientId = getGoogleAnalyticsClientId();
		}

		try {
			params.reCaptchaCode = await getRecaptchaToken();
		} catch (error) {
			console.error(error);
		}

		const urlParams = Object.keys(params)
			.map((key) => `${key}=${encodeURIComponent(params[key])}`)
			.join('&');

		window.location.assign(`${url}?${urlParams}`);
	};

	const onGoogleSsoClick = () => redirectToSsoUrl(ssoGoogleUrl);
	const onMicrosoftSsoClick = () => redirectToSsoUrl(ssoMicrosoftUrl);

	return { onGoogleSsoClick, onMicrosoftSsoClick };
};
